import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Home from './components/Home';
import UniversalBrowserView from './components/UniversalBrowserView';
import { AppSettingsProvider } from './context/AppSettingsContext';

const App: React.FC = () => {
  return (
    <AppSettingsProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/writings/*" element={<UniversalBrowserView />} />
        </Routes>
      </Router>
    </AppSettingsProvider>
  );
};

export default App;
